import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { provideToastr } from 'ngx-toastr';

import { authorizationInterceptor } from '../../core/authorization.interceptor';
import { ConfigService } from '../../core/services/config.service';
import { ProfileService } from '../profile/profile.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authorizationInterceptor])),
    provideRouter(routes),
    provideToastr({ progressBar: true, timeOut: 2000 }),
    provideAnimations(),
    provideAppInitializer(() => {
      const configService = inject(ConfigService);
      return configService.loadConfig();
    }),
    provideAppInitializer(() => {
      const profileService = inject(ProfileService);
      return profileService.refreshToken(true);
    }),
  ],
};
